const $doc = $(document);

/**
 * Add cart item(s)
 * @return {Void}
 */

$doc.on('click', '.js-ajax-add', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this
    .closest('form')
    .find('select[name="id"]')
    .val();
  const quantity = $this
    .closest('form')
    .find('input[name="quantity"]')
    .val();
  const items = [{ id, quantity }];

  $this.addClass('is-loading');

  Cart.add(items);
});

/**
 * Remove item
 * @return {Void}
 */

$doc.on('click', '.js-line-item-remove', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.data('key');
  const isCartItem = $this.closest('.js-cart-item').length;
  let isCartPage = isCartItem ? true : false;

  Cart.updateItem(0, id, null, isCartPage);
});
